import { render } from "./informationSon.vue?vue&type=template&id=1d3ebee2&scoped=true"
import script from "./informationSon.vue?vue&type=script&lang=js"
export * from "./informationSon.vue?vue&type=script&lang=js"

import "./informationSon.vue?vue&type=style&index=0&id=1d3ebee2&lang=less&scoped=true"

import exportComponent from "D:\\新建文件夹\\资料\\PC享赫生活\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3ebee2"]])

export default __exports__